module.exports = __webpack_public_path__ + "static/media/consumer-panel-bg.3575ac01.png";